import moment from 'moment';

export const getLastMonthRangeIncludingToday = (): { startDate: string; endDate: string } => {
  const endDate = moment(); // Día actual
  const startDate = moment(endDate).subtract(1, 'months'); // Un mes atrás

  return {
    startDate: startDate.format('DD/MM/YYYY'),
    endDate: endDate.format('DD/MM/YYYY'),
  };
}
